import { List } from 'immutable';
import { deletePropertyByPath } from '@client/shared/utils/jsUtils/jsUtils';

export const checkAuthorized = (permissions, userPermissions = List([])) => {
  if (!permissions || !permissions.length) {
    return true;
  } else if (permissions.length > userPermissions.size) {
    return false;
  }

  return permissions.every((permission) => {
    return (
      userPermissions &&
      userPermissions.find &&
      userPermissions.find((userPermission) => userPermission === permission)
    );
  });
};

export const checkEnabledFeature = (featureFlags, featureFlagsSettings) => {
  if (!featureFlags || !featureFlags.length || !featureFlagsSettings) {
    return true;
  }

  return featureFlags.every((flag) => {
    const foundFlag = featureFlagsSettings.get(flag);

    if (foundFlag === undefined) {
      return true;
    } else if (typeof foundFlag === 'boolean') {
      return foundFlag;
    }

    return false;
  });
};

export const checkOfficeIp = (
  shouldBeClientWithOfficeId,
  clientHasOfficeIp
) => {
  if (!shouldBeClientWithOfficeId) {
    return true;
  }

  return clientHasOfficeIp;
};

export const checkLoggedIn = (shouldBeLoggedIn, isAuthenticated) => {
  if (!shouldBeLoggedIn) {
    return true;
  }

  return isAuthenticated;
};

function isRouteAllowed(route, restrictions) {
  const routeShouldBeLoggedIn = route.RESTRICTIONS.shouldBeLoggedIn;

  const passedLoggedInCheck = checkLoggedIn(
    routeShouldBeLoggedIn,
    restrictions.get('shouldBeLoggedIn')
  );

  if (!passedLoggedInCheck) {
    return false;
  } else {
    const routePermissions = route.RESTRICTIONS.permissions;

    if (!routePermissions) {
      return true;
    } else {
      return (
        passedLoggedInCheck &&
        checkAuthorized(routePermissions, restrictions.get('permissions'))
      );
    }
  }
}

function forEachRoute(
  routes,
  restrictions,
  routesToDelete = [],
  parentPath = []
) {
  const routeSize = Object.keys(routes).length - 1;

  Object.entries(routes).forEach(([key, route], index) => {
    const childRoutes = route.ROUTES;

    if (childRoutes) {
      parentPath.push(key);
      parentPath.push('ROUTES');
      forEachRoute(childRoutes, restrictions, routesToDelete, parentPath);
    } else {
      const allowed = isRouteAllowed(route, restrictions);
      if (!allowed) {
        const toAdd = [...parentPath, key];
        routesToDelete.push(toAdd);
      }
    }

    if (routeSize === index) {
      // new parent
      parentPath.pop();
      parentPath.pop();
    }
  });
}

export function removeRestrictedRoutes(routes, restrictions) {
  let routesToDelete = [];

  forEachRoute(routes, restrictions, routesToDelete);

  let allowedRoutes = routes;

  routesToDelete.forEach((path) => {
    deletePropertyByPath(allowedRoutes, path.join('.'));
  });

  return allowedRoutes;
}
